import { autoMount } from '../../../utils/autoMount';
import { FirstGuide } from '../../../components/organisms/firstGuide';

autoMount({ FirstGuide });
